// Canonical quote-status list. Backend (`Quote.Status`) is a free string —
// this list is the UI's source of truth until a backend enum lands.
export const QUOTE_STATUSES = ['Draft', 'Sent', 'Accepted', 'Rejected', 'Expired', 'Converted'];

// Filter dropdown on /quotes — null value = no status filter.
export const QUOTE_STATUS_FILTER_OPTIONS = [
    { value: null, label: 'All statuses' },
    ...QUOTE_STATUSES.map(s => ({ value: s, label: s })),
];

// Edit dropdown on QuoteDetailsCard. `Converted` is shown but disabled —
// conversion is an action (ConvertToJob endpoint), not a metadata flip.
export const QUOTE_STATUS_EDIT_OPTIONS = QUOTE_STATUSES.map(s => ({
    value: s,
    label: s,
    isDisabled: s === 'Converted',
}));

export const STATUS_COLORS = {
    Draft:     { bg: '#e5e7eb', text: '#374151' },
    Sent:      { bg: '#dbeafe', text: '#2563eb' },
    Accepted:  { bg: '#d1fae5', text: '#059669' },
    Rejected:  { bg: '#fee2e2', text: '#dc2626' },
    Expired:   { bg: '#fef3c7', text: '#d97706' },
    Converted: { bg: '#ede9fe', text: '#7c3aed' },
};

// Auto-expired in the UI when a Sent quote's expiry date is in the past.
// Purely derived — no server state change, no schema.
export function isQuoteExpired(quote) {
    if (!quote || quote.status !== 'Sent' || !quote.expiryDate) return false;
    const exp = new Date(quote.expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return exp < today;
}
